import { format } from "date-fns";
import { useOutletContext } from "react-router-dom";

import { SessionsPageFilters } from "@/app/pages/sessions";
import { FilterControl } from "@/components/filter-control";
import { Calendar } from "@/components/ui/calendar";

type SideCalendarWrapperProps = {
  children: React.ReactNode;
  activeDays?: Date[];
};

export function SideCalendarWrapper({
  children,
  activeDays,
}: SideCalendarWrapperProps) {
  const { tableFilters: filters } = useOutletContext<{
    tableFilters: FilterControl<SessionsPageFilters>;
  }>();

  const handleDateSelect = (date: Date | undefined) => {
    if (date) {
      const dateKey = format(date, "yyyy-MM-dd");
      filters.setFilter("date", dateKey);

      // Scroll to the selected day after a short delay to allow DOM update
      setTimeout(() => {
        const element = document.getElementById(`day-${dateKey}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      filters.setFilter("date", format(new Date(), "yyyy-MM-dd"));
    }
  };

  return (
    <div className="rounded-md border border-border bg-background">
      <div className="flex flex-col-reverse gap-8 p-4 md:flex-row">
        <div className="flex flex-1 flex-col">{children}</div>
        <div className="self-start md:sticky md:top-4 md:z-10">
          <Calendar
            mode="single"
            selected={
              filters.filters.date ? new Date(filters.filters.date) : undefined
            }
            onMonthChange={(date) => {
              filters.setFilter("activeMonth", format(date, "yyyy-MM"));
            }}
            onSelect={handleDateSelect}
            activeDays={activeDays}
          />
        </div>
      </div>
    </div>
  );
}
